import React from "react";
import QRCode from "react-qr-code";
import Button from "../../../../components/ui/Button/Button";
import { convertSecondsToDate } from "../../../../helper/formatDate/formate-date";
import { Form } from "../../../../utils/Form/Form";

export default function QRSmartFactory({
  onSubmit,
  productCodeQR,
  defaultValue = {
    lotNo: "ABCDEF",
    qrNo: "123123123",
    manufacDate: "1682208000",
    expireDate: "1690502400",
  },
  handleToInventory,
}) {
  const isModeEdit = Object.keys(defaultValue ?? {})?.length !== 0;
  return (
    <Form
      onSubmit={(data) => onSubmit({ ...data, id: defaultValue?.id })}
      options={{
        defaultValue: {
          lotNo: defaultValue?.lotNo,
          manufacDate: defaultValue?.manufacDate,
          expireDate: defaultValue?.expireDate,
          qrNo: defaultValue?.qrNo,
          id: defaultValue?.id,
        },
      }}
    >
      {({ register, watch }) => {
        const formValues = watch();
        const checkIsEmpty = (obj) =>
          Object.values(obj).every((val) => val === null || val === "");

        const formEmpty = checkIsEmpty(formValues);
        return (
          <>
            <div className="flex items-center justify-between">
              <div className="w-full">
                <div className="flex border-x border-t border-primary-grey ">
                  <div className="bg-input-grey border-r border-primary-grey w-[40%] p-3">
                    상품번호
                  </div>
                  <div className="bg-white p-3 w-full">
                    {productCodeQR?.product?.productGroup?.productNo || "-"}
                  </div>
                </div>
                <div className="flex border-x border-t border-primary-grey ">
                  <div className="bg-input-grey border-r border-primary-grey w-[40%] p-3">
                    카테고리
                  </div>
                  <div className="bg-white p-3 w-full">
                    {productCodeQR?.productGroup?.productGroupCategory?.name}
                  </div>
                </div>
                <div className="flex border-x border-t border-primary-grey ">
                  <div className="bg-input-grey border-r border-primary-grey w-[40%] p-3">
                    상품명
                  </div>
                  <div className="bg-white p-3 w-full">
                    {productCodeQR?.name}
                  </div>
                </div>{" "}
                <div className="flex border-x border-t border-b border-primary-grey ">
                  <div className="bg-input-grey border-r border-primary-grey w-[40%] p-3">
                    REF(상품코드)
                  </div>
                  <div className="bg-white p-3 w-full">
                    {productCodeQR?.ref}
                  </div>
                </div>
              </div>
            </div>
            <div className="mt-10">
              <h2 className="text-[14px] font-bold mb-4">QR 정보</h2>
              <div>
                <div className="flex border-x border-t border-primary-grey ">
                  <div className="bg-input-grey border-r border-b border-primary-grey p-3 w-[25%] flex items-center">
                    <span>QR코드 입력정보</span>
                  </div>
                  <div className="w-full">
                    <div className="flex">
                      <div className="bg-input-grey border-r border-b border-primary-grey w-[30%] p-3 flex items-center">
                        LOT
                      </div>

                      <div className="bg-white px-4 py-2 w-full border-b border-primary-grey flex items-center">
                        {defaultValue?.lotNo}
                      </div>
                    </div>

                    <div className="flex">
                      <div className="bg-input-grey border-r border-b border-primary-grey w-[30%] p-3 flex items-center">
                        제조일자
                      </div>

                      <div className="bg-white px-4 py-2 w-full border-b border-primary-grey flex items-center">
                        {defaultValue?.manufacDate
                          ? convertSecondsToDate(defaultValue?.manufacDate)
                          : ""}
                      </div>
                    </div>
                    <div className="flex">
                      <div className="bg-input-grey border-r border-b border-primary-grey w-[30%] p-3 flex items-center">
                        유효일자
                      </div>

                      <div className="bg-white px-4 py-2 w-full border-b border-primary-grey flex items-center">
                        {defaultValue?.expireDate
                          ? convertSecondsToDate(defaultValue?.expireDate)
                          : ""}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex border-x border-t border-primary-grey ">
                  <div className="bg-input-grey border-r border-b border-primary-grey p-3 w-[25%] flex items-center">
                    <span>QR번호 등록정보</span>
                  </div>
                  <div className="w-full">
                    <div className="flex">
                      <div className="bg-input-grey border-r border-b border-primary-grey w-[30%] p-3 flex items-center">
                        QR번호
                      </div>

                      <div className="bg-white px-4 py-2 w-full border-b border-primary-grey flex items-center">
                        {defaultValue?.qrNo}
                      </div>
                    </div>

                    <div className="flex">
                      <div className="bg-input-grey border-r border-b border-primary-grey w-[30%] p-3 flex items-center">
                        QR이미지
                      </div>

                      <div className="bg-white px-4 py-2 w-full border-b border-primary-grey">
                        <div className="rounded-md border border-primary-grey w-24 h-24 flex items-center justify-center">
                          <QRCode
                            size={256}
                            style={{
                              height: "auto",
                              maxWidth: "100%",
                              width: "100%",
                              padding: "6px",
                            }}
                            value={defaultValue?.qrNo}
                            viewBox={`0 0 256 256`}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr className="my-4" />
            <div className="flex justify-end">
              <Button
                onClick={handleToInventory}
                width="w-36"
                borderColor="border-[#bbbbbb] border"
                text="재고 상세내역 이동"
              />
              <Button
                type="submit"
                // isDisabled={formEmpty && !isModeEdit}
                isDisabled={true}
                primary
                text="등록완료"
              />
            </div>
          </>
        );
      }}
    </Form>
  );
}
